import { ThemeMode } from "../../../types";

import type { ThemeColors } from "../../../types";

export const gray = {
  [ThemeMode.LIGHT]: {
    background: [1, 0, 0],
    foreground: [0.13, 0.028, 261.692],
    card: [1, 0, 0],
    "card-foreground": [0.13, 0.028, 261.692],
    popover: [1, 0, 0],
    "popover-foreground": [0.13, 0.028, 261.692],
    primary: [0.21, 0.034, 264.665],
    "primary-foreground": [0.985, 0.002, 247.839],
    secondary: [0.967, 0.003, 264.542],
    "secondary-foreground": [0.21, 0.034, 264.665],
    muted: [0.967, 0.003, 264.542],
    "muted-foreground": [0.551, 0.027, 264.364],
    accent: [0.967, 0.003, 264.542],
    "accent-foreground": [0.21, 0.034, 264.665],
    destructive: [0.577, 0.245, 27.325],
    "destructive-foreground": [0.985, 0.002, 247.839],
    success: [0.7999, 0.1816, 151.78],
    "success-foreground": [0.9848, 0, 0],
    border: [0.928, 0.006, 264.531],
    input: [0.928, 0.006, 264.531],
    ring: [0.707, 0.022, 261.325],
    "chart-1": [0.872, 0.01, 258.338],
    "chart-2": [0.551, 0.027, 264.364],
    "chart-3": [0.446, 0.03, 256.802],
    "chart-4": [0.373, 0.034, 259.733],
    "chart-5": [0.278, 0.033, 256.848],
    sidebar: [0.985, 0.002, 247.839],
    "sidebar-foreground": [0.13, 0.028, 261.692],
    "sidebar-primary": [0.21, 0.034, 264.665],
    "sidebar-primary-foreground": [0.985, 0.002, 247.839],
    "sidebar-accent": [0.967, 0.003, 264.542],
    "sidebar-accent-foreground": [0.21, 0.034, 264.665],
    "sidebar-border": [0.928, 0.006, 264.531],
    "sidebar-ring": [0.707, 0.022, 261.325],
  },
  [ThemeMode.DARK]: {
    background: [0.13, 0.028, 261.692],
    foreground: [0.985, 0.002, 247.839],
    card: [0.21, 0.034, 264.665],
    "card-foreground": [0.985, 0.002, 247.839],
    popover: [0.21, 0.034, 264.665],
    "popover-foreground": [0.985, 0.002, 247.839],
    primary: [0.928, 0.006, 264.531],
    "primary-foreground": [0.21, 0.034, 264.665],
    secondary: [0.278, 0.033, 256.848],
    "secondary-foreground": [0.985, 0.002, 247.839],
    muted: [0.278, 0.033, 256.848],
    "muted-foreground": [0.707, 0.022, 261.325],
    accent: [0.278, 0.033, 256.848],
    "accent-foreground": [0.985, 0.002, 247.839],
    destructive: [0.704, 0.191, 22.216],
    "destructive-foreground": [0.985, 0.002, 247.839],
    success: [0.627, 0.194, 149.214],
    "success-foreground": [0.985, 0, 0],
    border: [1, 0, 0, 0.1],
    input: [1, 0, 0, 0.15],
    ring: [0.551, 0.027, 264.364],
    "chart-1": [0.872, 0.01, 258.338],
    "chart-2": [0.551, 0.027, 264.364],
    "chart-3": [0.446, 0.03, 256.802],
    "chart-4": [0.373, 0.034, 259.733],
    "chart-5": [0.278, 0.033, 256.848],
    sidebar: [0.21, 0.034, 264.665],
    "sidebar-foreground": [0.985, 0.002, 247.839],
    "sidebar-primary": [0.488, 0.243, 264.376],
    "sidebar-primary-foreground": [0.985, 0.002, 247.839],
    "sidebar-accent": [0.278, 0.033, 256.848],
    "sidebar-accent-foreground": [0.985, 0.002, 247.839],
    "sidebar-border": [1, 0, 0, 0.1],
    "sidebar-ring": [0.551, 0.027, 264.364],
  },
} satisfies ThemeColors;
